/*
 * Lisboa by Luisa: keeps the cart drawer extras in sync with the cart.
 * - quantity discount progress (snippets/ll-cart-tiers.liquid)
 * - savings row (snippets/ll-cart-savings.liquid)
 * - free-shipping bar (snippets/ll-free-shipping-bar.liquid, if used)
 */
(function () {
  if (window.llCartExtrasInit) return;
  window.llCartExtrasInit = true;

  function money(cents) {
    var t = window.theme || {};
    if (typeof t.formatMoney === 'function') return t.formatMoney(cents, t.moneyFormat);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderTiers(cart) {
    document.querySelectorAll('[data-ll-tiers]').forEach(function (box) {
      var exclude = String(box.getAttribute('data-exclude') || '');
      var count = cart
        ? (cart.items || []).reduce(function (n, i) { return String(i.variant_id) === exclude ? n : n + i.quantity; }, 0)
        : parseInt(box.getAttribute('data-count'), 10) || 0;
      var tiers = (box.getAttribute('data-tiers') || '').split(',').map(function (t) {
        var p = t.split(':');
        return { qty: parseInt(p[0], 10), pct: parseInt(p[1], 10) };
      }).filter(function (t) { return t.qty > 0; });
      if (!tiers.length) return;

      var n = tiers.length;
      var reached = tiers.filter(function (t) { return count >= t.qty; }).length;
      var seg = 100 / n;
      var fill;
      if (reached === n) {
        fill = 100;
      } else {
        var from = reached ? tiers[reached - 1].qty : 0;
        var to = tiers[reached].qty;
        fill = reached * seg + Math.max(0, Math.min(1, (count - from) / (to - from))) * seg;
      }

      var text;
      if (reached === n) {
        text = box.getAttribute('data-msg-max').replace('[p]', tiers[n - 1].pct);
      } else {
        var missing = tiers[reached].qty - count;
        text = (missing === 1 ? box.getAttribute('data-msg-next-one') : box.getAttribute('data-msg-next-other'))
          .replace('[n]', missing).replace('[p]', tiers[reached].pct);
      }
      var textEl = box.querySelector('[data-ll-tiers-text]');
      if (textEl) textEl.innerHTML = text;
      var fillEl = box.querySelector('.ll-tiers__fill');
      if (fillEl) fillEl.style.width = fill + '%';
      box.querySelectorAll('.ll-tiers__steps li').forEach(function (li) {
        li.classList.toggle('is-reached', count >= parseInt(li.getAttribute('data-qty'), 10));
      });
      box.classList.toggle('is-empty', count === 0);
    });
  }

  function renderSavings(cart) {
    var total = 0;
    var titles = [];
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        total += a.amount;
        var title = ((a.discount_application && a.discount_application.title) || '').replace(/^\s*:\s*/, '').trim();
        if (title && titles.indexOf(title) === -1) titles.push(title);
      });
    });
    document.querySelectorAll('[data-ll-savings]').forEach(function (el) {
      el.classList.toggle('is-hidden', total === 0);
      var title = el.querySelector('[data-ll-savings-title]');
      if (title) title.textContent = el.getAttribute('data-label') || '';
      var amount = el.querySelector('[data-ll-savings-amount]');
      if (amount) amount.textContent = '\u2212' + money(total);
    });
  }

  function renderFreeShip(cart) {
    document.querySelectorAll('[data-ll-freeship]').forEach(function (bar) {
      var min = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var exclude = String(bar.getAttribute('data-exclude') || '');
      var total = cart.total_price;
      (cart.items || []).forEach(function (item) {
        if (String(item.variant_id) === exclude) total -= item.final_line_price;
      });
      var left = min - total;
      var done = min <= 0 || left <= 0;
      var pct = done ? 100 : Math.max(0, Math.min(100, Math.floor((total / min) * 100)));
      var text = bar.querySelector('[data-ll-freeship-text]');
      if (text) {
        text.innerHTML = done
          ? bar.getAttribute('data-msg-done')
          : bar.getAttribute('data-msg-left').replace('[amount]', money(left));
      }
      bar.classList.toggle('is-done', done);
      var fill = bar.querySelector('.ll-freeship__fill');
      if (fill) fill.style.setProperty('--ll-fill', pct + '%');
    });
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          renderTiers(cart);
          renderSavings(cart);
          renderFreeShip(cart);
        })
        .catch(function () {});
    }, 250);
  }

  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('theme:cart:add', refresh);

  function init() {
    renderTiers(null);
    var holder = document.querySelector('[data-cart-price-holder]');
    if (holder) new MutationObserver(refresh).observe(holder, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
